const formatDate = (isoDateString) => {
  if (!isoDateString) {
    return ''; // Return empty string or a default value if input is empty
  }

  const date = new Date(isoDateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return ''; // Return empty string or a default value if the date is invalid
  }

  const formatter = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const formattedDate = formatter.format(date);
  return formattedDate;
};

export default formatDate;
